// src/components/LoginScreen.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./Button";

export const LoginScreen = () => {
  const { loginApp } = useAuth();
  const [cpf, setCpf] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [timeoutWarning, setTimeoutWarning] = useState(false); 

  // --- CORREÇÃO: Uso do PUBLIC_URL padrão do React ---
  // Isso pega o caminho correto definido no package.json ("homepage") ou na build.
  // Garanta que o arquivo na pasta public se chame exatamente "brasao.png" (minúsculo).
  const brasaoSrc = `${process.env.PUBLIC_URL}/brasao.png`;

  useEffect(() => {
    if (localStorage.getItem('sessionTimeoutWarning')) {
      setTimeoutWarning(true);
      localStorage.removeItem('sessionTimeoutWarning');
    }
  }, []);

  const handleCpfChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 11) value = value.slice(0, 11);
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    setCpf(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setTimeoutWarning(false);
    setLoading(true);
    try {
      await loginApp(cpf, senha);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="max-w-sm w-full bg-white rounded-lg shadow-2xl p-8 m-4">
        
        {/* Imagem do Brasão */}
        <img 
            src={brasaoSrc} 
            alt="Brasão APMBB" 
            className="h-20 w-20 mx-auto mb-4 object-contain" 
            onError={(e) => { 
                console.error("Erro ao carregar imagem:", brasaoSrc); // Log para debug
                e.target.style.display = 'none'; // Esconde se falhar
            }}
        />
        
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-0">
          SIAAP
        </h2>
        
        <p className="text-center text-sm text-gray-500 mb-1 leading-tight">
          Sistema Integrado Acadêmico da APMBB
        </p>
        
        <p className="text-center text-gray-600 mb-6">Acesso ao Sistema</p>
        
        {timeoutWarning && (
            <div className="p-3 mb-4 bg-orange-100 border border-orange-400 text-orange-700 rounded-lg">
                Sua sessão expirou devido à inatividade. Por favor, faça login novamente.
            </div>
        )}

        {error && (
            <div className="p-3 mb-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              {error}
            </div>
          )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              CPF
            </label>
            <input
              type="text"
              value={cpf}
              onChange={handleCpfChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="000.000.000-00"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Senha
            </label>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="••••••••"
              required
            />
          </div>

          <Button type="submit" variant="primary" disabled={loading} className="w-full">
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
};